import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createApiCall } from 'services'
import { INTERNAL_USERS_QUERY_KEY } from './useInternalUsers'

type DeleteInternalUserPayload = {
  userId: string
}

type DeleteInternalUserResponse = {
  success: boolean
}

export const useDeleteInternalUser = () => {
  const queryClient = useQueryClient()

  return useMutation<DeleteInternalUserResponse, Error, DeleteInternalUserPayload>({
    mutationFn: async (payload) => {
      const { userId } = payload
      const response = await createApiCall({
        method: 'DELETE',
        url: `/admins/admin/platform-supervisors/${userId}`,
      })
      return response.data as DeleteInternalUserResponse
    },
    onSuccess: () => {
      // Invalidate internal users query to refetch the list
      queryClient.invalidateQueries({ queryKey: [INTERNAL_USERS_QUERY_KEY] })
    },
  })
}
